import { BoxProps, Flex } from '@chakra-ui/react';
import React from 'react';
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd';
import './DragAndDropList.css';

type DragAndDropListProps = BoxProps & {
  listElements: JSX.Element[];
  ids?: string[];
  onReorder?: (listElements: JSX.Element[]) => void;
  onDropEnd?: (result: DropResult) => void;
};

const reorderListElements = (
  list: JSX.Element[],
  startIndex: number,
  endIndex?: number
) => {
  if (!endIndex) {
    return list;
  }
  const [removed] = list.splice(startIndex, 1);
  list.splice(endIndex, 0, removed);
  return list;
};

export const DragAndDropList: React.FC<DragAndDropListProps> = ({
  listElements: initListElements,
  onReorder,
  onDropEnd,
  children,
  ids,
  ...props
}) => {
  let listElements = initListElements;

  const droppedOutsideTheList = (result: DropResult) => {
    return !result.destination;
  };

  const onDragEnd = (result: DropResult) => {
    if (droppedOutsideTheList(result)) {
      return;
    }
    listElements = reorderListElements(
      listElements,
      result.source.index,
      result.destination?.index
    );
    onReorder(listElements);
  };

  return (
    <Flex {...props}>
      <DragDropContext onDragEnd={onDropEnd ?? onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {listElements?.map((listElement, index) => (
                <Draggable
                  key={index}
                  draggableId={index.toString()}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <Flex
                      w="100%"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      userSelect="none"
                    >
                      {listElement}
                    </Flex>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Flex>
  );
};
